import { Action, ThunkDispatch } from '@reduxjs/toolkit';

import useConstraintDataByTypeInput from './constraint-data-by-type-input.controller';

const ID = 'constraint-data-by-type-input';
export interface ConstraintDataByTypeInputProps {
    dispatch: ThunkDispatch<any, any, Action>;
    formId: string;
    id?: string;
    label?: string;
    className?: string;
    required?: boolean;
}

export const ConstraintDataByTypeInput = (props: ConstraintDataByTypeInputProps) => {
    const viewProps = useConstraintDataByTypeInput(props);

    if (viewProps.content) return viewProps.content;
    return null;
};
